<template>
  <section class="ead-page">
    <titlebar :title-stack="['Conteúdo do curso']" /><b-loading
      :active="loading"
    />
    <div v-if="dados.curso">
      <header class="conteudo-header box">
        <div>
          <p class="conteudo-header__legenda">Conteúdo do curso</p>
          <div class="conteudo-header__titulo">
            <h1 class="title is-3 mb-0">{{ dados.curso.nome }}</h1>
            <b-tag :type="dados.curso.ativo ? 'is-success' : 'is-light'">
              {{ dados.curso.ativo ? 'Ativo' : 'Inativo' }}
            </b-tag>
          </div>
          <div class="conteudo-resumo">
            <span
              ><b-icon icon="view-grid" size="is-small" />{{ totalModulos }}
              módulos</span
            >
            <span
              ><b-icon icon="play-circle-outline" size="is-small" />{{
                totalAulas
              }}
              aulas</span
            >
            <span
              ><b-icon icon="help-circle-outline" size="is-small" />{{
                totalPerguntas
              }}
              perguntas</span
            >
          </div>
        </div>
        <div
          v-if="isInRole('rh-diretoria')"
          class="conteudo-header__acoes"
        >
          <router-link
            v-if="dados.curso.possuiAvaliacaoFinal"
            class="button"
            :to="{
              name: 'ead-avaliacao-conteudo',
              params: { id: $route.params.id },
            }"
            ><b-icon icon="clipboard-text-outline" size="is-small" />
            <span>Configurar avaliação</span></router-link
          >
          <b-button type="is-primary" icon-left="plus" @click="novoModulo"
            >Novo módulo</b-button
          >
        </div>
      </header>
      <b-message
        v-if="!dados.modulos || !dados.modulos.length"
        type="is-info"
      >
        Este curso ainda não possui módulos cadastrados.
      </b-message>
      <article class="modulo-card" v-for="m in dados.modulos" :key="m.id">
        <header class="modulo-header">
          <div class="modulo-identificacao">
            <span class="ordem-badge">{{ m.ordem }}</span>
            <div>
              <div class="titulo-com-status">
                <h2 class="title is-5 mb-0">{{ m.nome }}</h2>
                <b-tag v-if="!m.ativo" type="is-light">Inativo</b-tag>
              </div>
              <p v-if="m.descricao" class="has-text-grey mt-1">
                {{ m.descricao }}
              </p>
              <p class="modulo-contagem mt-1">
                {{ (m.aulas || []).length }}
                {{ (m.aulas || []).length === 1 ? 'aula' : 'aulas' }}
              </p>
            </div>
          </div>
          <div
            v-if="isInRole('rh-diretoria')"
            class="buttons mb-0"
          >
            <b-button
              size="is-small"
              icon-left="pencil"
              @click="editarModulo(m)"
              >Editar módulo</b-button
            >
            <b-button
              size="is-small"
              type="is-primary"
              icon-left="plus"
              @click="novaAula(m)"
              >Nova aula</b-button
            >
          </div>
        </header>
        <div v-if="!m.aulas || !m.aulas.length" class="estado-vazio">
          <b-icon icon="play-box-outline" />
          <span>Nenhuma aula cadastrada neste módulo.</span>
        </div>
        <section class="aula-card" v-for="a in m.aulas" :key="a.id">
          <header class="aula-header">
            <div class="aula-identificacao">
              <b-icon icon="play-circle-outline" type="is-primary" />
              <div>
                <div class="titulo-com-status">
                  <h3 class="has-text-weight-semibold">
                    {{ a.ordem }}. {{ a.nome }}
                  </h3>
                  <b-tag v-if="!a.ativo" type="is-light">Inativa</b-tag>
                </div>
                <div class="aula-meta">
                  <span v-if="a.duracaoEstimadaMinutos">
                    <b-icon icon="clock-outline" size="is-small" />
                    {{ a.duracaoEstimadaMinutos }} min
                  </span>
                  <span v-if="a.obrigatoria">
                    <b-icon icon="alert-circle-outline" size="is-small" />
                    Obrigatória
                  </span>
                </div>
              </div>
            </div>
            <div
              v-if="isInRole('rh-diretoria')"
              class="buttons mb-0"
            >
              <b-button
                size="is-small"
                icon-left="help-circle-outline"
                @click="novaPergunta(a)"
                >Nova pergunta</b-button
              >
              <b-button
                size="is-small"
                icon-left="pencil"
                @click="novaAula(m, a)"
                >Editar aula</b-button
              >
            </div>
          </header>
          <div v-if="a.perguntas && a.perguntas.length" class="perguntas-aula">
            <div class="perguntas-titulo">
              <span class="has-text-weight-semibold">Perguntas da aula</span>
              <b-tag rounded>{{ (a.perguntas || []).length }}</b-tag>
            </div>
            <div
              v-for="p in a.perguntas || []"
              :key="p.id"
              class="pergunta-item"
            >
              <span class="pergunta-ordem">{{ p.ordem }}</span>
              <div class="pergunta-dados">
                <p>{{ p.enunciado }}</p>
                <div class="tags mb-0 mt-2">
                  <b-tag type="is-info" outlined>{{ p.tipoDescricao }}</b-tag>
                  <b-tag v-if="p.obrigatoria" type="is-warning" outlined
                    >Obrigatória</b-tag
                  >
                  <b-tag v-if="!p.ativo" type="is-light">Inativa</b-tag>
                </div>
              </div>
              <b-button
                v-if="isInRole('rh-diretoria')"
                size="is-small"
                type="is-text"
                icon-left="pencil"
                @click="editarPergunta(a, p)"
                >Editar pergunta</b-button
              >
            </div>
          </div>
        </section>
      </article>
    </div>
    <b-modal :active.sync="modalModulo" has-modal-card :width="640"
      ><form class="modal-card ead-modal-card" @submit.prevent="salvarModulo">
        <header class="modal-card-head">
          <div class="modal-titulo">
            <b-icon icon="view-grid" type="is-primary" />
            <div>
              <p class="modal-card-title">
                {{ modulo.id ? 'Editar módulo' : 'Novo módulo' }}
              </p>
              <p class="modal-subtitulo">Organize as aulas em uma etapa do curso.</p>
            </div>
          </div>
        </header>
        <section class="modal-card-body">
          <b-field label="Nome do módulo"
            ><b-input required maxlength="160" v-model="modulo.nome" /></b-field
          ><b-field label="Descrição"
            ><b-input
              type="textarea"
              rows="3"
              v-model="modulo.descricao"
              placeholder="Explique brevemente o conteúdo deste módulo"
          /></b-field>
          <div class="form-linha">
            <b-field label="Ordem de exibição"
              ><b-numberinput min="1" v-model="modulo.ordem"
            /></b-field>
            <div class="campo-status">
              <span class="label">Status</span>
              <b-switch v-model="modulo.ativo">Módulo ativo</b-switch>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="modalModulo = false">Cancelar</b-button>
          <b-button
            native-type="submit"
            type="is-primary"
            icon-left="content-save"
            :loading="salvandoModulo"
            >Salvar módulo</b-button
          >
        </footer>
      </form></b-modal
    >
    <b-modal :active.sync="modalAula" has-modal-card :width="700"
      ><form class="modal-card ead-modal-card" @submit.prevent="salvarAula">
        <header class="modal-card-head">
          <div class="modal-titulo">
            <b-icon icon="play-circle-outline" type="is-primary" />
            <div>
              <p class="modal-card-title">
                {{ aula.id ? 'Editar aula' : 'Nova aula' }}
              </p>
              <p class="modal-subtitulo">Configure o vídeo e os detalhes da aula.</p>
            </div>
          </div>
        </header>
        <section class="modal-card-body">
          <b-field label="Nome da aula"
            ><b-input required maxlength="160" v-model="aula.nome" /></b-field
          ><b-field label="Descrição"
            ><b-input type="textarea" rows="3" v-model="aula.descricao"
          /></b-field>
          <b-field label="Link do YouTube"
            ><b-input
              required
              icon="youtube"
              v-model="aula.linkYoutube"
              placeholder="https://www.youtube.com/watch?v=..."
          /></b-field>
          <div class="form-linha">
            <b-field label="Ordem de exibição"
              ><b-numberinput min="1" v-model="aula.ordem"
            /></b-field>
            <b-field label="Duração estimada (minutos)"
              ><b-numberinput min="1" v-model="aula.duracaoEstimadaMinutos"
            /></b-field>
          </div>
          <div class="opcoes-linha">
            <b-switch v-model="aula.obrigatoria">Aula obrigatória</b-switch>
            <b-switch v-model="aula.ativo">Aula ativa</b-switch>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="modalAula = false">Cancelar</b-button>
          <b-button
            native-type="submit"
            type="is-primary"
            icon-left="content-save"
            :loading="salvandoAula"
            >Salvar aula</b-button
          >
        </footer>
      </form></b-modal
    >
    <b-modal :active.sync="modalPergunta" has-modal-card :width="760"
      ><form class="modal-card ead-modal-card" @submit.prevent="salvarPergunta">
        <header class="modal-card-head">
          <div class="modal-titulo">
            <b-icon icon="help-circle-outline" type="is-primary" />
            <div>
              <p class="modal-card-title">
                {{ pergunta.id ? 'Editar pergunta' : 'Nova pergunta' }}
              </p>
              <p class="modal-subtitulo">
                Defina como o aluno deverá responder durante a aula.
              </p>
            </div>
          </div>
        </header>
        <section class="modal-card-body">
          <b-field label="Enunciado"
            ><b-input
              required
              type="textarea"
              rows="3"
              maxlength="2000"
              v-model="pergunta.enunciado"
              placeholder="Digite a pergunta que será apresentada ao aluno"
          /></b-field>
          <div class="form-linha">
            <b-field label="Tipo de resposta">
              <b-select expanded v-model="pergunta.tipo" @input="alterarTipoPergunta">
                <option :value="0">Resposta aberta</option>
                <option :value="1">Múltipla escolha</option>
              </b-select>
            </b-field>
            <b-field label="Ordem de exibição">
              <b-numberinput min="1" v-model="pergunta.ordem" />
            </b-field>
          </div>
          <div v-if="pergunta.tipo === 1" class="alternativas-bloco">
            <div class="alternativas-cabecalho">
              <div>
                <p class="has-text-weight-semibold">Alternativas</p>
                <p class="is-size-7 has-text-grey">
                  Selecione o círculo da resposta correta.
                </p>
              </div>
              <b-button
                size="is-small"
                icon-left="plus"
                @click.prevent="adicionarAlternativa"
                >Adicionar alternativa</b-button
              >
            </div>
            <div
              v-for="(a, i) in pergunta.alternativas"
              :key="a.id || 'nova-' + i"
              class="alternativa-row"
            >
              <b-radio
                v-model="correta"
                :native-value="i"
                :aria-label="'Marcar alternativa ' + (i + 1) + ' como correta'"
              />
              <span class="alternativa-numero">{{ i + 1 }}</span>
              <b-input
                expanded
                required
                maxlength="1000"
                v-model="a.descricao"
                :placeholder="'Alternativa ' + (i + 1)"
              />
              <b-button
                size="is-small"
                type="is-text"
                icon-left="delete-outline"
                title="Remover alternativa"
                :disabled="pergunta.alternativas.length <= 2"
                @click.prevent="removerAlternativa(i)"
              />
            </div>
          </div>
          <div class="opcoes-linha">
            <b-switch v-model="pergunta.obrigatoria">Pergunta obrigatória</b-switch>
            <b-switch v-model="pergunta.ativo">Pergunta ativa</b-switch>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button @click="modalPergunta = false">Cancelar</b-button>
          <b-button
            native-type="submit"
            type="is-primary"
            icon-left="content-save"
            :loading="salvandoPergunta"
            >Salvar pergunta</b-button
          >
        </footer>
      </form></b-modal
    >
  </section>
</template>
<script>
import http from '@/http'
import titlebar from '@/components/titlebar.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'EadCursoConteudo',
  components: { titlebar },
  data: () => ({
    dados: {},
    loading: false,
    modalModulo: false,
    modalAula: false,
    modalPergunta: false,
    modulo: {},
    aula: {},
    pergunta: {},
    moduloAtual: null,
    aulaAtual: null,
    correta: 0,
    salvandoModulo: false,
    salvandoAula: false,
    salvandoPergunta: false,
  }),
  computed: {
    ...mapGetters(['isInRole']),
    totalModulos() {
      return (this.dados.modulos || []).length
    },
    totalAulas() {
      return (this.dados.modulos || []).reduce(
        (total, modulo) => total + (modulo.aulas || []).length,
        0
      )
    },
    totalPerguntas() {
      return (this.dados.modulos || []).reduce(
        (total, modulo) =>
          total +
          (modulo.aulas || []).reduce(
            (subtotal, aula) => subtotal + (aula.perguntas || []).length,
            0
          ),
        0
      )
    },
  },
  mounted() {
    this.carregar()
  },
  methods: {
    alternativa() {
      return { id: 0, descricao: '', correta: false, ordem: 1, ativo: true }
    },
    carregar() {
      this.loading = true
      http
        .get(`/api/ead-conteudo/cursos/${this.$route.params.id}`)
        .then((r) => (this.dados = r.data))
        .finally(() => (this.loading = false))
    },
    novoModulo() {
      this.modulo = {
        id: 0,
        nome: '',
        descricao: '',
        ordem: (this.dados.modulos || []).length + 1,
        ativo: true,
      }
      this.modalModulo = true
    },
    editarModulo(modulo) {
      this.modulo = { ...modulo }
      this.modalModulo = true
    },
    salvarModulo() {
      this.salvandoModulo = true
      const req = this.modulo.id
        ? http.put(`/api/ead-conteudo/modulos/${this.modulo.id}`, this.modulo)
        : http.post(
            `/api/ead-conteudo/cursos/${this.$route.params.id}/modulos`,
            this.modulo
          )
      req.then(() => {
        this.modalModulo = false
        this.carregar()
      }).finally(() => (this.salvandoModulo = false))
    },
    novaAula(m, a) {
      this.moduloAtual = m
      this.aula = a
        ? { ...a }
        : {
            id: 0,
            nome: '',
            descricao: '',
            linkYoutube: '',
            ordem: m.aulas.length + 1,
            duracaoEstimadaMinutos: null,
            obrigatoria: true,
            ativo: true,
          }
      this.modalAula = true
    },
    salvarAula() {
      this.salvandoAula = true
      const base = `/api/ead-conteudo/modulos/${this.moduloAtual.id}/aulas`
      const req = this.aula.id
        ? http.put(`${base}/${this.aula.id}`, this.aula)
        : http.post(base, this.aula)
      req.then(() => {
        this.modalAula = false
        this.carregar()
      }).finally(() => (this.salvandoAula = false))
    },
    novaPergunta(a) {
      this.abrirPergunta(a)
    },
    editarPergunta(a, p) {
      this.abrirPergunta(a, p)
    },
    abrirPergunta(a, p = null) {
      this.aulaAtual = a
      if (p) {
        const alternativas = (p.alternativas || []).map((alternativa) => ({
          ...alternativa,
          ativo: true,
        }))
        const correta = alternativas.findIndex((alternativa) =>
          Boolean(alternativa.correta)
        )
        this.correta = correta >= 0 ? correta : 0
        this.pergunta = { ...p, alternativas }
        this.alterarTipoPergunta(this.pergunta.tipo)
      } else {
        this.correta = 0
        this.pergunta = {
          id: 0,
          enunciado: '',
          tipo: 0,
          obrigatoria: false,
          ordem: (a.perguntas || []).length + 1,
          ativo: true,
          alternativas: [this.alternativa(), this.alternativa()],
        }
      }
      this.modalPergunta = true
    },
    adicionarAlternativa() {
      this.pergunta.alternativas.push(this.alternativa())
    },
    alterarTipoPergunta(tipo) {
      if (tipo === 1) {
        while (this.pergunta.alternativas.length < 2)
          this.pergunta.alternativas.push(this.alternativa())
      }
    },
    removerAlternativa(index) {
      if (this.pergunta.alternativas.length <= 2) return
      this.pergunta.alternativas.splice(index, 1)
      if (this.correta === index) this.correta = 0
      else if (this.correta > index) this.correta--
    },
    normalizarAlternativas(lista, correta) {
      lista.forEach((a, i) => {
        a.ordem = i + 1
        a.correta = i === correta
      })
    },
    salvarPergunta() {
      this.salvandoPergunta = true
      if (this.pergunta.tipo === 1)
        this.normalizarAlternativas(this.pergunta.alternativas, this.correta)
      else this.pergunta.alternativas = []
      http
        .post(
          `/api/ead-conteudo/aulas/${this.aulaAtual.id}/perguntas`,
          this.pergunta
        )
        .then(() => {
          this.modalPergunta = false
          this.$buefy.toast.open({
            message: 'Pergunta salva.',
            type: 'is-success',
          })
          this.carregar()
        })
        .finally(() => (this.salvandoPergunta = false))
    },
  },
}
</script>
<style scoped>
.conteudo-header,
.conteudo-header__titulo,
.conteudo-resumo,
.conteudo-header__acoes,
.modulo-header,
.modulo-identificacao,
.titulo-com-status,
.aula-header,
.aula-identificacao,
.aula-meta,
.perguntas-titulo,
.modal-titulo,
.opcoes-linha,
.alternativas-cabecalho,
.alternativa-row {
  display: flex;
  align-items: center;
}

.conteudo-header {
  justify-content: space-between;
  gap: 1.5rem;
  border-left: 4px solid #00b89c;
  margin-bottom: 1.5rem;
}

.conteudo-header__legenda {
  color: #7a7a7a;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.35rem;
  text-transform: uppercase;
}

.conteudo-header__titulo,
.titulo-com-status {
  flex-wrap: wrap;
  gap: 0.75rem;
}

.conteudo-resumo {
  color: #7a7a7a;
  flex-wrap: wrap;
  gap: 1rem;
  margin-top: 0.85rem;
}

.conteudo-resumo span,
.aula-meta span {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
}

.conteudo-header__acoes {
  flex-wrap: wrap;
  gap: 0.5rem;
  justify-content: flex-end;
}

.modulo-card {
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(10, 10, 10, 0.05);
  margin-bottom: 1.25rem;
  overflow: hidden;
}

.modulo-header,
.aula-header,
.perguntas-titulo,
.alternativas-cabecalho {
  justify-content: space-between;
  gap: 1rem;
}

.modulo-header {
  background: #fafafa;
  border-bottom: 1px solid #ededed;
  padding: 1rem 1.25rem;
}

.modulo-identificacao,
.aula-identificacao,
.modal-titulo {
  gap: 0.75rem;
}

.ordem-badge,
.pergunta-ordem,
.alternativa-numero {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  flex: 0 0 auto;
  font-weight: 700;
  justify-content: center;
}

.ordem-badge {
  background: #00b89c;
  color: #fff;
  height: 2.25rem;
  width: 2.25rem;
}

.modulo-contagem,
.aula-meta,
.modal-subtitulo {
  color: #7a7a7a;
  font-size: 0.8rem;
}

.aula-card {
  margin: 1rem;
  border: 1px solid #ededed;
  border-radius: 7px;
  overflow: hidden;
}

.aula-header {
  padding: 0.9rem 1rem;
}

.aula-meta {
  flex-wrap: wrap;
  gap: 0.85rem;
  margin-top: 0.35rem;
}

.perguntas-aula {
  background: #fafafa;
  border-top: 1px solid #ededed;
  padding: 0.85rem 1rem;
}

.perguntas-titulo {
  margin-bottom: 0.6rem;
}

.pergunta-item {
  align-items: center;
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 6px;
  display: grid;
  gap: 0.75rem;
  grid-template-columns: auto minmax(0, 1fr) auto;
  padding: 0.75rem;
}

.pergunta-item + .pergunta-item {
  margin-top: 0.5rem;
}

.pergunta-ordem,
.alternativa-numero {
  background: #f0f0f0;
  color: #4a4a4a;
  height: 1.75rem;
  width: 1.75rem;
}

.pergunta-dados {
  min-width: 0;
}

.estado-vazio {
  align-items: center;
  color: #7a7a7a;
  display: flex;
  gap: 0.5rem;
  justify-content: center;
  padding: 1.5rem;
}

.estado-vazio--compacto {
  justify-content: flex-start;
  padding: 0.5rem 0;
}

.ead-modal-card {
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
}

.modal-card-head {
  background: #fafafa;
}

.modal-card-foot {
  justify-content: flex-end;
}

.modal-subtitulo {
  margin-top: 0.2rem;
}

.form-linha {
  display: grid;
  gap: 1rem;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}


.campo-status {
  padding-top: 0.15rem;
}

.opcoes-linha {
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-top: 1rem;
}

.alternativas-bloco {
  background: #fafafa;
  border: 1px solid #ededed;
  border-radius: 7px;
  margin-top: 0.5rem;
  padding: 1rem;
}

.alternativas-cabecalho {
  margin-bottom: 0.85rem;
}

.alternativa-row {
  background: #fff;
  border: 1px solid #ededed;
  border-radius: 6px;
  gap: 0.65rem;
  padding: 0.6rem;
}

.alternativa-row + .alternativa-row {
  margin-top: 0.5rem;
}

@media screen and (max-width: 768px) {
  .conteudo-header,
  .modulo-header,
  .aula-header,
  .alternativas-cabecalho {
    align-items: flex-start;
    flex-direction: column;
  }

  .conteudo-header__acoes,
  .conteudo-header__acoes .button {
    width: 100%;
  }

  .form-linha {
    grid-template-columns: 1fr;
  }

  .pergunta-item {
    align-items: flex-start;
    grid-template-columns: auto minmax(0, 1fr);
  }

  .pergunta-item > .button {
    grid-column: 2;
  }

  .alternativa-row {
    align-items: flex-start;
  }
}
</style>
